import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const ProjectSettingsBranchRestrictionsLoadable = Loadable({
  loading: LoadingPage,
  loader: () => import('./branch-restrictions'),
});
